import React from "react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";

class BoxScoresWidgetRowPrimaryCellsTitleProps extends BaseProps {
  title: String;
}

export const BoxScoresWidgetRowPrimaryCellsTitle = (({title}: BoxScoresWidgetRowPrimaryCellsTitleProps) => {
  return (
    <div className={classnames(styles.row_primary_cells_header_title)}>
      {title}
    </div>
  )
});